// Referral auto-tracker — captures ?ref=CODE from URL, stores in localStorage for 30 days,
// exposes helpers to auto-track user actions (newsletter, contribution, etc.)
import api from "@/lib/api";

const KEY = "in21_ref";
const TTL_DAYS = 30;

export function captureRefFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get("ref") || "").trim().toUpperCase();
    if (!code || !/^IN21[A-F0-9]{6}$/.test(code)) return null;
    const existing = getStoredRef();
    if (existing?.code === code) return existing;
    const store = { code, at: Date.now(), expires_at: Date.now() + TTL_DAYS * 86400 * 1000 };
    localStorage.setItem(KEY, JSON.stringify(store));
    return store;
  } catch { return null; }
}

export function getStoredRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s?.code || (s.expires_at && s.expires_at < Date.now())) {
      localStorage.removeItem(KEY);
      return null;
    }
    return s;
  } catch { return null; }
}

export function clearStoredRef() {
  try { localStorage.removeItem(KEY); } catch {}
}

export async function autoTrackReferral(email, name = "", source = "newsletter") {
  const ref = getStoredRef();
  if (!ref?.code || !email) return { skipped: true };
  try {
    const { data } = await api.post("/referrals/track", {
      ref_code: ref.code, new_email: email, new_name: name, source,
    });
    // Consume the code once tracked successfully (prevents double-counts)
    if (data?.ok) clearStoredRef();
    return data;
  } catch { return { skipped: true }; }
}
